import { IMAGE_HOST_URL } from "~/constants/all";

export const makeUrlConsistentSlashes = (url: string): string => {
  return url.replace(/(https?:\/\/)|(\/{2,})/g, (match, p1) => p1 || "/");
};

export const createImageUrl = (path: string): string => {
  if (!path) return "";

  let imageUrl = path;

  // Check that the path doesn't already have the host URL.
  if (path && path.startsWith(IMAGE_HOST_URL || "")) {
    // Remove the host URL from the path.
    imageUrl = path.replace(IMAGE_HOST_URL || "", "");
  }

  return makeUrlConsistentSlashes(`${IMAGE_HOST_URL}/${imageUrl}`);
};

/**
 * Removes the 'http://' or 'https://' protocol from a given URL string.
 *
 * @param {string} url - The URL from which the protocol should be removed.
 * @return {string} The URL without the 'http://' or 'https://' protocol.
 */
export const websiteUrl = (url: string): string => {
  if (!url) return url;

  return url.replace(/^https?:\/\//, "");
};

/**
 * Adds the 'https://' protocol to a given URL string if it doesn't already have one.
 *
 * @param {string} url - The URL to which the 'https://' protocol should be added.
 * @return {string} The URL with the 'https://' protocol.
 */
export const forceWebsiteHttpsIfNone = (url: string): string => {
  if (!url) return url;

  return url.match(/^(http|https):\/\//) ? url : `https://${url}`;
};
